<template>
  <div>
    <gg-card>
      <gg-card-header>
        Manage Protected URLs
      </gg-card-header>
      <gg-card-text>
        <v-row>
          <v-col cols="12" class="d-flex">
            <gg-btn
              secondary
              :disabled="!upEnabled"
              @click="loadDirs(parent)"
            >
              <v-icon size="20" class="mr-1">mdi-arrow-up</v-icon>
              Up One Level
            </gg-btn>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="children"
              :loading="loading"
              :items-per-page="100"
              hide-default-footer
            >
              <template v-slot:item.path="{ item }">
                <v-icon size="20" color="primary" class="mr-2">
                  mdi-{{ hasAuth(item) ? 'folder-lock' : 'folder' }}
                </v-icon>
                <a href="#" @click.prevent="loadDirs(item.path)">
                  {{ dirName(item.path) }}
                </a>
              </template>
              <template v-slot:item.private="{ item }">
                <template v-if="hasAuth(item)">
                  <v-icon size="18" color="primary">mdi-lock</v-icon>
                  Yes
                </template>
                <template v-else>No</template>
              </template>
              <template v-slot:item.manage="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <gg-btn v-on="on" v-bind="attrs">
                      Manage
                      <v-icon class="ml-1">mdi-chevron-down</v-icon>
                    </gg-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="openAddUser(item.path)">
                      <v-list-item-title>
                        Add User
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openManageUsers(item.path)">
                      <v-list-item-title>
                        Manage Users
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="hasAuth(item)" @click="openRemove(item)">
                      <v-list-item-title>
                        Disable Protection
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </gg-card-text>
    </gg-card>
    <manage-users-modal
      v-model="manageUsersModal"
      :path="selectedPath"
      @close="selectedPath = ''"
    />
    <add-user-modal
      v-model="addUserModal"
      :path="selectedPath"
      @close="selectedPath = ''"
    />
    <remove-auth-modal
      v-model="removeModal"
      :path="selectedPath"
      :authname="selectedAuth"
      @close="selectedPath = ''"
      @removed="loadCurrent"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ManageUsersModal from './ManageUsersModal'
import AddUserModal from './AddUserModal'
import RemoveAuthModal from './RemoveAuthModal'

export default {
  name: 'ProtectedUrlsList',
  components: {
    ManageUsersModal,
    AddUserModal,
    RemoveAuthModal
  },
  data () {
    return {
      items: [],
      headers: [
        {
          text: 'Directory',
          value: 'path'
        },
        {
          text: 'Private',
          value: 'private'
        },
        {
          text: 'Manage',
          value: 'manage'
        },
      ],
      loading: false,
      manageUsersModal: false,
      addUserModal: false,
      removeModal: false,
      selectedPath: '',
      selectedAuth: ''
    }
  },
  computed: {
    ...mapGetters({
      current: 'protected_urls/current',
      children: 'protected_urls/children',
      parent: 'protected_urls/parent'
    }),
    upEnabled () {
      return this.parent !== this.current
    }
  },
  methods: {
    ...mapActions({
      getProtectedUrls: 'protected_urls/getProtectedUrls',
      reportError: 'reportError'
    }),
    async loadDirs (dir) {
      this.loading = true
      try {
        await this.getProtectedUrls({ dir, _username: this.$route.query.user })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    loadCurrent () {
      this.loadDirs(this.current)
    },
    dirName (path) {
      return path.split('/').slice(-1)[0]
    },
    hasAuth (path) {
      return path.state.auth_type === 'Basic'
    },
    openManageUsers (path) {
      this.selectedPath = path
      this.manageUsersModal = true
    },
    openAddUser (path) {
      this.selectedPath = path
      this.addUserModal = true
    },
    openRemove (path) {
      this.selectedPath = path.path
      this.selectedAuth = path?.state?.auth_name || ''
      this.removeModal = true
    }
  },
  mounted () {
    this.loadDirs('/')
  }
}
</script>
